// extracted by mini-css-extract-plugin
module.exports = {"text":"LzaMv9"};